import { render, staticRenderFns } from "./lq007a.vue?vue&type=template&id=c58190d8"
import script from "./lq007a.vue?vue&type=script&lang=js"
export * from "./lq007a.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports